<template>
  <div class="gonggaoson-warp">
    <div class="container">
      <div class="w clearfix">
        <div class="main clearfix">
          <div class="aside">
            <div class="header">
              <p>其他公告</p>
            </div>
            <div class="list-box">
              <ul>
                <li @click="xinwsonvr(index)" v-for="(item,index) in noticelistv" :key="item.id" class="li-listxw">
                  <p class="title">{{noticelistv[index].title}}</p>
                  <p class="time">发布时间：{{noticelisttime[index]}}</p>
                </li>

              </ul>
            </div>
          </div>
          <div class="section">
            <div class="article">
              <div class="son-title">
                <h1>{{noticeall.title}}</h1>
                <div class="info">
                  <div>
                    <span class="gson-liu">浏览量：4530</span>
                    <!-- <span class="gson-liu">浏览量：{{noticeall.status}}</span> -->

                  </div>
                  <div>
                    <span class="gson-liu">发布时间：</span>
                    <span class="gson-liu">{{xwtime}}</span>
                  </div>
                </div>
              </div>

              <section class="son-sec">
                  <!-- <p>{{noticeall.message}}</p> -->
                  <p v-html="textsal"></p>
                <!-- <p>各院校、直属党支部，校属各单位：</p>
                <p>
                  为进一步提升二级网站建设和管理水平，促进网站内容不断丰富和更新，学校决定开展2019年优秀二级网站评比工作，现将有关要求通知如下
                </p>
                <p>一、评比内容：</p>
                <p>1.网站管理:</p>
                <p>（1）分管领导：部门主要领导分管负责。</p>

                <p>（2）专门人员：安排专人负责网站全面管理工作。</p>
                <p>
                  （3）信息安全：信息发布须按照规定的格式和程序进行，未经部门领导审核的文字、视频信息不得随意上传，坚持三级审核制度，发布时须注明作者、审核和发布人姓名等信息。
                </p>
                <p>
                  （4）栏目设置：教学单位二级网站要设置院（部）简介、机构设置、师资队伍、专业（课程）建设、科研概况、学生工作、最新动态（新闻）、校友风采、招生就业、联系方式等栏目（无学生的单位不考核学生工作、招生就业和校友风采栏目，可根据本单位特点自行设置3个左右的新栏目。）；管理与教辅单位二级网站要设置单位（部门）简介、机构设置、规章制度（常用文件）、服务指南、通知公告、联系方式等栏目。栏目安排合理定位清晰、分类层次清晰，栏目名称准确，具有简明、直观、易操作的特点，栏目内容充实，页面图文并茂。
                </p>
                <p>
                  （5）信息严谨：二级网站所使用的二级单位名称、学校图标（LOGO）、校名题字等其他标志性文字或图片必须与学校网站主页上的保持一致。信息内容真实、准确，健康，无科学性错误，涉及数据要与学校相关部门保持一致。
                </p>
                <p>2.网站总体效果:</p>
                <p>
                  （1）网站页面布局：布局结构清楚合理，整洁美观，文字、图片、标志清晰，视觉效果好;层次分明，可读性好，页面字体清晰，大小适宜，文字图片排版美观，显示图片应与本部门内容或发布信息相关
                </p>
                <p>（2）标题信息：标题信息传达准确，体现部门职能特色。</p>
                <p>
                  （3）内容排版：页面设计整齐，内容规范，没有变形的页面和文字，没有表格错行，文字错位等现象。二级网站所有发布的信息文字的字号、字体要统一，图片的大小要一致。
                </p> -->
                <div class="son-bots">
                  <p class="son-bot">大赛宣传部</p>
                  <p class="son-bot2">{{xwtime}}</p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
    <botTom></botTom>
  </div>
</template>

<script>
import axios from "axios";
import Gonggaoson from "../css/Gonggaoson.css";

import botTom from "./BotTom";
export default {
  data() {
    return {
      noticeall: "",//id下新闻
      noticelistv:'',//新闻列表
      xwtime:'',//id下新闻时间
      noticelisttime:[],//新闻列表时间
      textsal:''
    };
  },
  mounted(){
this.noticev();
this.noticelist();
  },
  methods: {
      // 时间
 timestampToTime(timestamp) {
    var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var  Y = date.getFullYear() + '';
  var   M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  var   D = this.change(date.getDate()) + '';
  var   h = this.change(date.getHours()) + ':';
  var   m = this.change(date.getMinutes()) + ':';
  var   s = this.change(date.getSeconds());
    return Y+'年'+M+'月'+D+'日';
},
change(t) {
    if (t < 10) {
        return "0" + t;
    } else {
        return t;
    }

},
    //   新闻详情
    noticev() {
      let id = JSON.parse(sessionStorage.getItem("xinwid"));
      let fa = new window.FormData;
      fa.append('id',id);
      axios({
        method: "post",
        url: this.$apiUrl + "/index.php/index/notice",
        // timeout: 1000,
        data:fa
      })
        .then((res) => {
          this.noticeall = res.data.data;

        var t=this.noticeall.create_time;
this.xwtime = this.timestampToTime(t);

          // console.log(res.data.data.text)
          this.textsal = res.data.data.text;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //右侧新闻列表
    noticelist() {

      axios({
        method: "get",
        url: this.$apiUrl + "/index.php/index/notice",
        // timeout: 1000,

      })
        .then((res) => {
          this.noticelistv = res.data.data.data;
        //   this.noticelisttime = res.data.data.create_time;
          for (let index = 0; index < this.noticelistv.length; index++) {
        this.noticelisttime.push(this.timestampToTime(this.noticelistv[index].create_time));

          }
        //   console.log(this.noticelisttime)
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 列表点击
    xinwsonvr(index){
        // console.log(this.noticelistv[index].id);
        this.noticelistv[index].id;
        sessionStorage.setItem('xinwid',this.noticelistv[index].id);
        this.noticev();
    }
  },
  components: {
    botTom,
  },
};
</script>

<style>
.gson-liu{
  font-size: 0.14rem;
}
</style>



// WEBPACK FOOTER //
// src/components/GongGaoson.vue